<template>
  <div class="drop-spot-select">
    <TitleFrame
      text="立ち寄り箇所選択"
      :show-return="true"
      @click-close="onClickClose"
    >
      <template slot="contents">
        <div class="content-area">
          <SpotExampleBar
            :selectedSpot="currentSelectedSpotType"
            @select-spot="onSelectSpotType"
          />
          <div class="map-area">
            <GoogleMap
              ref="$googleMap"
              v-if="
                currentDepLatLng &&
                currentDesLatLng &&
                currentSearchState === 'select'
              "
              :isGetOriginalApiData="isGetOriginalApiData"
              :current="current"
            />
            <CongestionStatusDialog :selected="!!selectedSpot" />
            <DropSpotListDialog
              v-if="currentOriApiData.length !== 0"
              :selected="!!selectedSpot"
              :spotList="currentOriApiData"
              @click-spot="onClickSpot"
              :current="current"
            />
            <FilterDialog
              v-if="currentOriApiData.length !== 0"
              :selected="!!selectedSpot"
              :current="current"
            />
            <NoDropDialog
              v-if="isShowNoDropDialog"
              :selected="!!selectedSpot"
              :current="current"
              @clickSeachNearSpots="onClickSeachNearSpots"
            />
          </div>
          <p v-if="selectedSpot">
            {{ selectedSpot.name }}
          </p>
          <div class="selected-item">
            <DropSpotItem
              v-if="selectedSpot"
              :current="current"
              :selectedSpot="selectedSpot"
              @click-spot="onClickSpot"
            />
          </div>
        </div>
      </template>
    </TitleFrame>
    <DropSpotSelectModal
      v-if="selectedSpot && showModal"
      :current="current"
      @click-close="onClickCloseModal"
    />
  </div>
</template>



<script>
import { mapState, mapMutations } from "vuex";
import TitleFrame from "@/components/Templates/TitleFrame";
import TextLink from "@/components/Atoms/TextLink";
import SpotExampleBar from "@/components/DropSpotSelect/SpotExampleBar";
import GoogleMap from "@/components/Organisms/GoogleMap";
import DropSpotItem from "@/components/Organisms/DropSpotItem";
import DropSpotSelectModal from "@/components/Modals/DropSpotSelectModal";
import CongestionStatusDialog from "@/components/DropSpotSelect/CongestionStatusDialog";
import DropSpotListDialog from "@/components/DropSpotSelect/DropSpotListDialog";
import FilterDialog from "@/components/DropSpotSelect/FilterDialog";
import NoDropDialog from "@/components/DropSpotSelect/NoDropDialog";

export default {
  name: "drop-spot-select",
  components: {
    TitleFrame,
    SpotExampleBar,
    GoogleMap,
    TextLink,
    DropSpotItem,
    DropSpotSelectModal,
    CongestionStatusDialog,
    DropSpotListDialog,
    FilterDialog,
    NoDropDialog,
  },
  props: {
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState([
      "currentLat",
      "currentLng",
      "selectedSpotType",
      "shoModalAll",
      "DepLatLng",
      "DesLatLng",
      "selectedSpotData",
      "searchState",
      "originalApiData",
      "currentPageName",
      "search",
    ]),
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentSearchState() {
      if (this.current === "RouteSearch") {
        return this.searchState.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.searchState.jyutai;
      }
    },
    selectedSpot() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotData.jyutai;
      }
    },
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
    },
    currentOriApiData() {
      if (this.current === "RouteSearch") {
        return this.originalApiData.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.originalApiData.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
    currentSelectedSpotType() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotType.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotType.jyutai;
      }
    },
    isShowNoDropDialog() {
      return this.currentDepLatLng &&
      this.currentDesLatLng &&
      this.currentSearchState === 'select' &&
      this.currentSearch.departure !== this.currentSearch.destination &&
      this.currentSearch.timeIndex != 0;
    },
    isGetOriginalApiData() {
      return !this.isShowNoDropDialog;
    }
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    ...mapMutations([
      "loadingStartMini",
      "loadingEndMini",
      "setSelectedSpotData",
      "setSelectedSpotType",
      "setSearchState",
      "setDesLatLng",
      "setDepLatLng",
      "setOriginalApiData",
    ]),
    onClickSpot() {
      this.showModal = true;
    },
    onClickCloseModal() {
      this.showModal = false;
    },
    onClickClose() {
      this.setSelectedSpotData(undefined);
      this.setSearchState("search");
      this.setOriginalApiData([]);
    },
    onSelectSpotType(e) {
      this.setSelectedSpotType(e);
    },
    onClickSeachNearSpots() {
      this.$refs.$googleMap.getOriginalApiData();
    },
    init() {
      if (this.currentSearchState === "select") {
        this.loadingStartMini();
        if (this.current !== this.currentPageName) return;

        if (!this.currentDepLatLng) {
          this.setSearchState("search");
        }
        this.setSelectedSpotType("観光");
        this.loadingEndMini();
      }
    },
  },
  watch: {
    currentSearchState: {
      immideate: true,
      handler: async function () {
        this.init();
      },
    },
  },
  async mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.drop-spot-select {
  height: 100%;
  z-index: 1;
  position: relative;
}
.map-area {
  height: 100%;
}

.selected-item {
  position: absolute;
  bottom: 1rem;
  width: calc(100vw - 0.5rem * 2);
  left: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/DropSpotSelect.vue